import React from 'react'
import AuthBlock from '../components/Auth/AuthBlock'

function Auth() {
  return (
    <div className='Auth'>
        <AuthBlock />
    </div>
  )
}

export default Auth